enum PinRequired {
    REQUIRED = "REQUIRED",
    CARDHOLDER = "CARDHOLDER",
    NOT_REQUIRED = "NOTREQUIRED"
}

export default PinRequired;